import styles from "./index.module.less";

import { CSSProperties, ReactNode } from "react";

interface MenuItem {
  name: string;
  onclick?: (item: MenuItem) => void;
}

interface DropDownProps<T extends MenuItem> {
  useClick?: boolean;
  children?: ReactNode;
  menu?: {
    style?: CSSProperties;
    list?: T[];
    onclick?: (item: T) => void;
    customPanel?: ReactNode;
  };
  isShowPanel?: boolean;
}

const DropDown = <T extends MenuItem>(props: DropDownProps<T>) => {
  const { useClick, isShowPanel, menu = {} } = props;
  return (
    <div className={useClick ? styles.DropDownByClick : styles.DropDown}>
      <div>{props.children}</div>
      <div
        className={
          useClick && isShowPanel
            ? styles.hoverContentByClick
            : styles.hoverContent
        }
        style={{
          ...menu?.style,
        }}
      >
        {props.menu?.customPanel
          ? props.menu?.customPanel
          : props.menu?.list?.map((item) => {
              return (
                <div
                  className={styles.hoverContentItem}
                  key={item.name}
                  onClick={() => {
                    menu?.onclick?.(item);
                  }}
                >
                  {item?.name}
                </div>
              );
            })}
      </div>
    </div>
  );
};

export default DropDown;
